import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import {
  ButtonApproval,
  ContentBtnCmmt,
  ContentComment,
  ContentLeftBtnCmmt,
  ContentRightBtnCmmt,
  ContentTitleComment,
  GeneralStyle,
  LinkCancelCmmt,
  LinkSaveEditCmmt,
  NewComment,
  useStyles,
} from "./CommentsComponent.styled";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import RadioButtonUncheckedIcon from "@material-ui/icons/RadioButtonUnchecked";
import { ReactComponent as DeleteComment } from "../../assets/svg/delete-comment.svg";
import AddCommentIcon from "@material-ui/icons/AddComment";
import { ReactComponent as CloseIcon } from "../../themes/Icons/close_icon.svg";
import { IconButton, Tooltip, TextField } from "@material-ui/core";
import { theme as themeConfig } from "../../themes/themes";
import { getStateLoginComplete } from "../../containers/LayoutHome/stateLogin";
import {
  CREATE_APPROVER_COMMENT,
  UPDATE_APPROVER_COMMENT,
  CHANGE_STATE_SURVEY,
} from "../../GraphQL/Mutations";
import { useMutation } from "@apollo/client";
import { NotificationManager } from "react-notifications";
import moment from "moment";
import ModalLoader from "../ModalLoader/ModalLoader";
import { ROLES } from "../../util/RolesConstants";

const CommentsComponent = ({
  idSurvey,
  comments,
  handleComments,
  renderAgain,
  setrenderAgain,
  surveyStateId,
  isApproverForSurvey,
  setComments,
}) => {
  const classes = useStyles();
  const [userComplete] = useState(getStateLoginComplete());
  const [createApproverComment] = useMutation(CREATE_APPROVER_COMMENT);
  const [updateApproverComment] = useMutation(UPDATE_APPROVER_COMMENT);
  const [changeStateSurvey] = useMutation(CHANGE_STATE_SURVEY);
  const [newComment, setNewComment] = useState(false);
  const [checkedComment, setCheckedComment] = useState(false);
  const [showLoader, setShowLoader] = useState(false);

  let addComment = () => {
    let commentsArr = [...comments];
    commentsArr.push({
      comment: "",
      idApprover: userComplete.userId,
      idSurvey: idSurvey,
      solved: false,
      idApproverComment: null,
      createDate: new Date(),
      isEdit: true,
    });
    setComments(commentsArr);
  };

  let saveComment = (item) => {
    item.isEdit = false;
    let data = {
      idApprover: userComplete.userId,
      idSurvey: idSurvey,
      comment: newComment,
    };
    createApproverComment({
      variables: {
        idApprover: data.idApprover,
        idSurvey: data.idSurvey,
        comment: data.comment,
      },
    })
      .then((response) => {
        if (response.data.createApproverComment.withError) {
          NotificationManager.error("Error creating comments", "", 5000);
        } else {
          NotificationManager.success("The new comment is created", "", 5000);
          setrenderAgain(!renderAgain);
        }
      })
      .catch((error) => {
        const errorMessage = error.message.split("\n")[0];
        NotificationManager.error(errorMessage, "", 5000);
      });
  };

  let updateComment = (item) => {
    item.isEdit = false;
    let data = {
      idApproverComment: item.idApproverComment,
      comment: newComment,
    };
    updateApproverComment({
      variables: {
        idApproverComment: data.idApproverComment,
        comment: data.comment,
      },
    })
      .then((response) => {
        if (response.data.updateApproverComment.withError) {
          NotificationManager.error("Error updating comment", "", 5000);
        } else {
          NotificationManager.success("The comment is updated", "", 5000);
          setrenderAgain(!renderAgain);
        }
      })
      .catch((error) => {
        const errorMessage = error.message.split("\n")[0];
        NotificationManager.error(errorMessage, "", 5000);
      });
  };
  let editComment = (item, index, value) => {
    let record = comments.map((e, i) => {
      if (i === index) {
        e.isEdit = value;
      }
      return e;
    });
    setComments(record);
  };

  let handleChangeComment = (item) => {
    setNewComment(item.currentTarget.value);
  };

  let handleCheck = (item, check) => {
    let data = {
      idApproverComment: item.idApproverComment,
      solved: check,
    };
    updateApproverComment({
      variables: {
        idApproverComment: data.idApproverComment,
        solved: data.solved,
      },
    })
      .then((response) => {
        if (response.data.updateApproverComment.withError) {
          NotificationManager.error("Error updating comment", "", 5000);
        } else {
          NotificationManager.success("The comment is solved", "", 5000);
          setrenderAgain(!renderAgain);
        }
      })
      .catch((error) => {
        const errorMessage = error.message.split("\n")[0];
        NotificationManager.error(errorMessage, "", 5000);
      });
  };

  let handleApprove = () => {
    setShowLoader(true);
    let variable = {
      idSurvey: idSurvey,
      newSurveyState: "PENDING_ACTIVATION",
    };
    changeStateSurvey({
      variables: variable,
    })
      .then((value) => {
        if (value.data.changeStateSurvey.withError) {
          NotificationManager.error("Error approving comments", "", 5000);
        } else {
          NotificationManager.success("The comments are approved", "", 5000);
          handleComments();
          setrenderAgain(!renderAgain);
        }
        setShowLoader(false);
      })
      .catch((error) => {
        const errorMessage = error.message.split("\n")[0];
        NotificationManager.error(errorMessage, "", 5000);
      });
  };

  let handleSendBackWithComments = () => {
    setShowLoader(true);
    let variable = {
      idSurvey: idSurvey,
      newSurveyState: "REVIEWED_WITH_COMMENTS",
    };

    changeStateSurvey({
      variables: variable,
    })
      .then((value) => {
        if (value.data.changeStateSurvey.withError) {
          NotificationManager.error(
            value.data.changeStateSurvey.message,
            "",
            5000
          );
        } else {
          NotificationManager.success(
            "The survey are sending back with comments",
            "",
            5000
          );
          handleComments();
          setrenderAgain(!renderAgain);
        }
        setShowLoader(false);
      })
      .catch((error) => {
        const errorMessage = error.message.split("\n")[0];
        NotificationManager.error(errorMessage, "", 5000);
      });
  };

  let handleDelete = (item) => {
    comments.splice(item, 1);
    setrenderAgain(!renderAgain);
  };

  useEffect(() => {
    let countChecked = comments
      .filter((f) => f.solved)
      .map((element) => {
        if (element.solved && !element.isEdit) {
          return element;
        }
      });

    if (countChecked.length === comments.length) {
      setCheckedComment(true);
    } else {
      setCheckedComment(false);
    }
  }, [comments]);

  return (
    <GeneralStyle>
      <Row
        className="justify-content-center px-2 py-1"
        style={{
          backgroundColor: themeConfig.background.secondary,
          border: "1px solid #9d9d9d4c",
          boxSizing: "border-box",
          boxShadow: "0px 4px 4px #0000003f",
        }}
      >
        <Col md={12}>
          <div className="d-flex justify-content-end">
            <Tooltip title="close">
              <IconButton
                className="align-right"
                onClick={() => handleComments()}
              >
                <CloseIcon />
              </IconButton>
            </Tooltip>
          </div>
        </Col>
        {userComplete.roleId !== ROLES.AGENT &&
          userComplete.roleId !== ROLES.WELLNESS_PROFESSIONAL &&
          isApproverForSurvey && (
            <>
              <Col md={6}>
                <ButtonApproval
                  isNotDisabled={
                    surveyStateId === 6 &&
                    surveyStateId !== 7 &&
                    !checkedComment
                  }
                  disabled={
                    surveyStateId !== 6 && surveyStateId === 7 && checkedComment
                  }
                  onClick={() => {
                    if (
                      surveyStateId === 6 &&
                      surveyStateId !== 7 &&
                      !checkedComment
                    ) {
                      handleSendBackWithComments();
                    }
                  }}
                >
                  Send back with comments
                </ButtonApproval>
              </Col>
              <Col md={6}>
                <ButtonApproval
                  isNotDisabled={checkedComment}
                  disabled={!checkedComment}
                  active={true}
                  onClick={() => {
                    if (checkedComment) {
                      handleApprove();
                    }
                  }}
                >
                  Approve
                </ButtonApproval>
              </Col>
            </>
          )}

        {isApproverForSurvey && <hr />}
        <Col md={12}>
          {comments &&
            comments.map((element, index) => {
              return (
                <Row key={index} className="mb-2">
                  <Col md={isApproverForSurvey ? 10 : 12}>
                    <NewComment
                      bgState={element.isEdit || !isApproverForSurvey}
                    >
                      <ContentTitleComment>
                        <b>Comment {index}</b>
                        <span>
                          {moment(element.createDate).format("YYYY-MM-DD")}
                        </span>
                      </ContentTitleComment>
                      <ContentComment>
                        {element.isEdit && isApproverForSurvey ? (
                          <TextField
                            id="comment-description"
                            defaultValue={element.comment}
                            variant="standard"
                            onChange={(e) => handleChangeComment(e)}
                          />
                        ) : (
                          <p>{element.comment}</p>
                        )}
                      </ContentComment>
                      {userComplete.roleId !== ROLES.AGENT &&
                        userComplete.roleId !== ROLES.WELLNESS_PROFESSIONAL &&
                        isApproverForSurvey && (
                          <ContentBtnCmmt>
                            <ContentLeftBtnCmmt>
                              {element.idApproverComment === null && (
                                <DeleteComment
                                  className={classes.delete}
                                  onClick={() => handleDelete(index)}
                                />
                              )}
                            </ContentLeftBtnCmmt>
                            <ContentRightBtnCmmt>
                              {element.isEdit ? (
                                <>
                                  <LinkSaveEditCmmt
                                    onClick={() => {
                                      if (element.idApproverComment) {
                                        updateComment(element);
                                      } else {
                                        saveComment(element);
                                      }
                                    }}
                                  >
                                    {element.idApproverComment
                                      ? "Update"
                                      : "Save"}
                                  </LinkSaveEditCmmt>
                                  &nbsp;|&nbsp;
                                  <LinkCancelCmmt
                                    onClick={() =>
                                      editComment(element, index, false)
                                    }
                                  >
                                    Cancel
                                  </LinkCancelCmmt>
                                </>
                              ) : (
                                <LinkSaveEditCmmt
                                  onClick={() =>
                                    editComment(element, index, true)
                                  }
                                >
                                  Edit
                                </LinkSaveEditCmmt>
                              )}
                            </ContentRightBtnCmmt>
                          </ContentBtnCmmt>
                        )}
                    </NewComment>
                  </Col>
                  {userComplete.roleId !== ROLES.AGENT &&
                    userComplete.roleId !== ROLES.WELLNESS_PROFESSIONAL &&
                    isApproverForSurvey && (
                      <Col md={2}>
                        {element.solved ? (
                          <CheckCircleOutlineIcon
                            style={{ color: themeConfig.text.primary, cursor: "pointer" }}
                            onClick={() => handleCheck(element, false)}
                          />
                        ) : (
                          <RadioButtonUncheckedIcon
                            style={{ color: themeConfig.text.primary, cursor: "pointer" }}
                            onClick={() => handleCheck(element, true)}
                          />
                        )}
                      </Col>
                    )}
                </Row>
              );
            })}
        </Col>
        {userComplete.roleId !== ROLES.AGENT &&
          userComplete.roleId !== ROLES.WELLNESS_PROFESSIONAL &&
          isApproverForSurvey && (
            <Col md={12} className="d-flex justify-content-end">
              <ButtonApproval
                isNotDisabled={true}
                active={true}
                addCommentStyle={true}
                onClick={() => {
                  addComment();
                }}
              >
                <AddCommentIcon style={{ transform: "scaleX(-1)" }} /> Add
                Comment
              </ButtonApproval>
            </Col>
          )}
      </Row>
      {showLoader && <ModalLoader />}
    </GeneralStyle>
  );
};

export default CommentsComponent;
